// libs
import React, { memo, useEffect } from 'react';

// hooks
import useNotifyApi from 'shared/components/Notify/hooks/useNotifyApi';

// components
import { useToastContext, TOASTER_TYPES } from 'shared/components/Toast';

// styles
import { Container, Button } from './styles';

// constants
import { TEXTS } from 'shared/components/Notify/constants';

// defs
interface INotifyProps {
  customerEmail: string;
  productId: string;
  onNotified?: VoidFunction;
}

function DesktopNotify(props: INotifyProps) {
  const { showToast } = useToastContext();

  const {
    setUserEmail,
    onNotifyClick,
    isApiSuccess,
    isErrorInEmail,
    inProgress,
    userEmail,
    reset,
  } = useNotifyApi(props);

  const updateEmail: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const email = e.currentTarget.value;
    setUserEmail(email);
  };

  const onSubmit: React.FormEventHandler = (e) => {
    e.preventDefault();
    onNotifyClick();
  };

  useEffect(() => {
    if (isErrorInEmail) {
      showToast({
        type: TOASTER_TYPES.ERROR,
        message: TEXTS.INVALID_EMAIL,
        hideTime: 2400,
      });
    }
  }, [isErrorInEmail, showToast]);

  useEffect(() => {
    if (isApiSuccess) {
      showToast({
        type: TOASTER_TYPES.INFO,
        message: TEXTS.SUCCESS_MESSAGE,
        hideTime: 2400,
      });
    }
  }, [isApiSuccess, showToast]);

  return (
    <Container onSubmit={onSubmit} data-test="notify">
      <div className="nd-container">
        <input
          type="text"
          className="nd-email"
          placeholder="Email Address"
          id="notify_email"
          value={userEmail}
          onChange={updateEmail}
          data-test="email-input"
          data-at="notify-input"
          onFocus={reset}
        />
        <Button
          inProgress={inProgress}
          data-test="btn-notify"
          data-at="notify-btn"
          className="notify-btn"
        >
          {TEXTS.NOTIFY}
        </Button>
      </div>
    </Container>
  );
}

export default memo(DesktopNotify);
